import {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import type {AxiosError} from 'axios';
import {ROUTE} from '@/constants/main/route';
import throwToast from '@/utils/ui/toast';
import {ApiErrorResponse} from '@/api/help/objection/type';
import {HTTP_STATUS} from '@/constants/help';

// 에러 상태 코드별 라우팅 매핑
// 500: 문의하기 페이지
// 409: 나의 문의/신고내역 페이지
const ERROR_ROUTE_MAP: Record<number, string> = {
  [HTTP_STATUS.CONFLICT]: ROUTE.HELP.MY_INQUIRY,
  [HTTP_STATUS.INTERNAL_SERVER_ERROR]: ROUTE.HELP.INQUIRY,
} as const;

const DEFAULT_ERROR_ROUTE = ROUTE.HELP.INDEX;

const DEFAULT_ERROR_MESSAGE = '오류가 발생했습니다. 다시 시도해 주세요.';

const useObjectionErrorHandler = (
  isError: boolean,
  error: AxiosError<ApiErrorResponse> | null,
) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isError || !error?.response) {
      return;
    }

    const {status: statusCode} = error.response;
    const errorMessage = error.response.data?.message || DEFAULT_ERROR_MESSAGE;

    throwToast(errorMessage);

    const targetRoute = ERROR_ROUTE_MAP[statusCode] || DEFAULT_ERROR_ROUTE;
    navigate(targetRoute, {replace: true});
  }, [isError, error, navigate]);
};

export default useObjectionErrorHandler;
